export const CURRENCY = [
    {
        short: 'USD',
        long: 'U.S. Dollar($)',
        sign: '$'
    },
    {
        short: 'AUD',
        long: 'Australian Dollar($)',
        sign: '$'

    },
    {
        short: 'CAD',
        long: 'Canadian Dollar(CA$)',
        sign: '$'

    },
    {
        short: 'GBP',
        long: 'Pound Sterling(£)',
        sign: '£'
    },
    {
        short: 'NZD',
        long: 'New Zealand Dollar($)',
        sign: '$'
    }
];


// WEBPACK FOOTER //
// ./src/constants/currencies.js